export default __webpack_public_path__ + "static/media/removeRed.9bfdbbd7.svg";